module.exports = __webpack_public_path__ + "img/customers.49e8e24b.png";